import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Language';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import axios from 'axios';

// Suppress unhandled promise rejections & runtime errors from optional browser APIs like ServiceWorkers on localhost
if (typeof window !== 'undefined') {
  const isSwError = (msg) => {
    const s = String(msg || '');
    return (
      s.includes('ServiceWorker') ||
      s.includes('OneSignal') ||
      s.includes('fetching the script') ||
      s.includes('OneSignalSDKWorker')
    );
  };

  window.addEventListener('error', (event) => {
    const msg = String(event.message || event.error?.message || '');
    if (isSwError(msg)) {
      console.warn('Suppressed ServiceWorker dev runtime notice:', msg);
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      event.preventDefault();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reasonMsg = String(event.reason?.message || event.reason || '');
    if (isSwError(reasonMsg)) {
      console.warn('Suppressed ServiceWorker background initialization notice:', reasonMsg);
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      event.preventDefault();
    }
  });
}

axios.interceptors.request.use(
  (config) => {
    const registerUser = localStorage.getItem('Register_User');
    let token = localStorage.getItem('token');
    if (registerUser) {
      try {
        const user = JSON.parse(registerUser);
        if (user && user.token) {
          token = user.token;
        }
      } catch (err) {
        console.error('Error parsing Register_User token:', err);
      }
    }
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 404) {
      console.warn(`[Axios 404] Resource not found: ${error?.config?.url}`);
    }
    return Promise.reject(error);
  }
);

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

let portalRoot = document.getElementById('portal-root');
if (!portalRoot) {
  portalRoot = document.createElement('div');
  portalRoot.id = 'portal-root';
  document.body.appendChild(portalRoot);
}

const client = AgoraRTC.createClient({ mode: "rtc", codec: "h264" });

root.render(
  <React.StrictMode>
    <AgoraRTCProvider client={client}>
      <App />
    </AgoraRTCProvider>
  </React.StrictMode>
);

reportWebVitals();
